export default "/_next/static/sounds/scott_last_breath-10d187534e964da7af6481afcd857730.mp3";